import React from "react";

export default function MyComponent(props) {
  return (
    <>
      <div className="div">
        <div className="div-2">
          <div className="div-3">
            <div className="div-4">
              <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/1c1f7f949264b43dc2741d62e020fc90b0652d332877f3ba5d8c4174153ca9ea?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                className="img"
              />
              <div className="div-5">
                <div className="div-6">Home</div>
                <div className="div-7">Attorneys</div>
                <div className="div-8">Practice Areas</div>
                <div className="div-9">About Us</div>
              </div>
              <div className="div-10">Contact Now</div>
            </div>
            <div className="div-11">
              <div className="div-12">
                <div className="column">
                  <div className="div-13">
                    <div className="div-14">
                      <span style={{fontWeight: 500}}>You don’t have to </span>
                      <br />
                      <span style={{fontWeight: 700}}>Fight them Alone.</span>
                    </div>
                    <div className="div-15">
                      Lorem ipsum dolor sit amet consectetur adipiscing elit
                      blandit, curabitur sodales conubia ut inceptos faucibus
                      himenaeos tortor eget, hac massa gravida arcu interdum
                      proin curae.
                    </div>
                    <div className="div-16">
                      <img
                        loading="lazy"
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/ce6ddc1b6f36146ff16a7d1fe9abf76f12bd9b77196c10416d5aa0838fd4dc7d?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                        className="img-2"
                      />
                      <div className="div-17">Enter your eamil address</div>
                      <div className="div-18">Let’s Talk</div>
                    </div>
                  </div>
                </div>
                <div className="column-2">
                  <img
                    loading="lazy"
                    srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/b91b0ed69bd21fee6159c576e7e9737a52d4eff38a05a72a7c777fbf29cb23d2?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/b91b0ed69bd21fee6159c576e7e9737a52d4eff38a05a72a7c777fbf29cb23d2?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/b91b0ed69bd21fee6159c576e7e9737a52d4eff38a05a72a7c777fbf29cb23d2?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/b91b0ed69bd21fee6159c576e7e9737a52d4eff38a05a72a7c777fbf29cb23d2?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/b91b0ed69bd21fee6159c576e7e9737a52d4eff38a05a72a7c777fbf29cb23d2?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/b91b0ed69bd21fee6159c576e7e9737a52d4eff38a05a72a7c777fbf29cb23d2?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/b91b0ed69bd21fee6159c576e7e9737a52d4eff38a05a72a7c777fbf29cb23d2?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/b91b0ed69bd21fee6159c576e7e9737a52d4eff38a05a72a7c777fbf29cb23d2?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                    className="img-3"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="div-19">
          <div className="div-20">
            <div className="div-21">
              Let’s Introduce
              <br />
              Ourself
            </div>
            <div className="div-22" />
            <div className="div-23">
              <div className="div-24">Criminal Lawyer</div>
              <div className="div-25">
                Amet minim mollit non deserunt ullamco est
                <br />
                sit aliqua dolor do amet sint. Velit officia consequatduis
                <br />
                enim velit mollit Exercitation.
              </div>
            </div>
          </div>
          <div className="div-26">Why Choose us?</div>
          <div className="div-27">
            <div className="div-28">
              <div className="column-3">
                <div className="div-29">
                  <img
                    loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/e2d94800c0fc47e6212950325c8e3929834a05a7ee7046c175f4d41f23cf89fc?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                    className="img-4"
                  />
                  <div className="div-30">98% Success Rate</div>
                  <div className="div-31">
                    Amet minim mollit non deserunt ullamco est
                    <br />
                    sit aliqua dolor do amet sint. Velit officia
                    <br />
                    consequatduis enim velit mollit Exer.
                  </div>
                  <div className="div-32">Read More</div>
                </div>
              </div>
              <div className="column-4">
                <div className="div-33">
                  <img
                    loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/7ea8e3266dc2c45ed02f07062a0189fc3c0a35f8c7499630d1c5e007f34ca246?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                    className="img-5"
                  />
                  <div className="div-34">100% Success Rate</div>
                  <div className="div-35">
                    Amet minim mollit non deserunt ullamco est
                    <br />
                    sit aliqua dolor do amet sint. Velit officia
                    <br />
                    consequatduis enim velit mollit Exer.
                  </div>
                  <div className="div-36">Read More</div>
                </div>
              </div>
              <div className="column-5">
                <div className="div-37">
                  <img
                    loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/7ea8e3266dc2c45ed02f07062a0189fc3c0a35f8c7499630d1c5e007f34ca246?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                    className="img-6"
                  />
                  <div className="div-38">100% Success Rate</div>
                  <div className="div-39">
                    Amet minim mollit non deserunt ullamco est
                    <br />
                    sit aliqua dolor do amet sint. Velit officia
                    <br />
                    consequatduis enim velit mollit Exer.
                  </div>
                  <div className="div-40">Read More</div>
                </div>
              </div>
            </div>
          </div>
          <div className="div-41">Area of Practices</div>
          <div className="div-42">
            <div className="div-43">
              <div className="column-6">
                <div className="div-44">
                  <img
                    loading="lazy"
                    srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/7e5f30cc223fde47c3fd54a3a62427c997c71482fb4eb1604f2ab894378b1426?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/7e5f30cc223fde47c3fd54a3a62427c997c71482fb4eb1604f2ab894378b1426?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/7e5f30cc223fde47c3fd54a3a62427c997c71482fb4eb1604f2ab894378b1426?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/7e5f30cc223fde47c3fd54a3a62427c997c71482fb4eb1604f2ab894378b1426?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/7e5f30cc223fde47c3fd54a3a62427c997c71482fb4eb1604f2ab894378b1426?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/7e5f30cc223fde47c3fd54a3a62427c997c71482fb4eb1604f2ab894378b1426?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/7e5f30cc223fde47c3fd54a3a62427c997c71482fb4eb1604f2ab894378b1426?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/7e5f30cc223fde47c3fd54a3a62427c997c71482fb4eb1604f2ab894378b1426?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                    className="img-7"
                  />
                  BUSINESS LAW
                </div>
              </div>
              <div className="column-7">
                <div className="div-46">
                  <img
                    loading="lazy"
                    srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/a43d8b3510015cf8a8c85344bf213c076a66d4c76de0f9a6cf70951abc574601?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/a43d8b3510015cf8a8c85344bf213c076a66d4c76de0f9a6cf70951abc574601?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/a43d8b3510015cf8a8c85344bf213c076a66d4c76de0f9a6cf70951abc574601?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/a43d8b3510015cf8a8c85344bf213c076a66d4c76de0f9a6cf70951abc574601?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/a43d8b3510015cf8a8c85344bf213c076a66d4c76de0f9a6cf70951abc574601?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/a43d8b3510015cf8a8c85344bf213c076a66d4c76de0f9a6cf70951abc574601?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/a43d8b3510015cf8a8c85344bf213c076a66d4c76de0f9a6cf70951abc574601?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/a43d8b3510015cf8a8c85344bf213c076a66d4c76de0f9a6cf70951abc574601?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                    className="img-8"
                  />
                  Partnership LAW
                </div>
              </div>
            </div>
          </div>
          <div className="div-48">
            <div className="div-49">
              <div className="column-8">
                <div className="div-50">
                  <img
                    loading="lazy"
                    srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/0ac89827def33670b562c5934a92f6d18a1e3a74b299b47dce4751121d1d8c06?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/0ac89827def33670b562c5934a92f6d18a1e3a74b299b47dce4751121d1d8c06?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/0ac89827def33670b562c5934a92f6d18a1e3a74b299b47dce4751121d1d8c06?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/0ac89827def33670b562c5934a92f6d18a1e3a74b299b47dce4751121d1d8c06?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/0ac89827def33670b562c5934a92f6d18a1e3a74b299b47dce4751121d1d8c06?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/0ac89827def33670b562c5934a92f6d18a1e3a74b299b47dce4751121d1d8c06?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/0ac89827def33670b562c5934a92f6d18a1e3a74b299b47dce4751121d1d8c06?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/0ac89827def33670b562c5934a92f6d18a1e3a74b299b47dce4751121d1d8c06?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                    className="img-9"
                  />
                  REAL ESTATE LAW
                  <br />
                </div>
              </div>
              <div className="column-9">
                <div className="div-52">
                  <img
                    loading="lazy"
                    srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/f706ae1e9e3f2b18d649c3bb9795c5ce14346fb818bd30f34011834af64b320c?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/f706ae1e9e3f2b18d649c3bb9795c5ce14346fb818bd30f34011834af64b320c?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/f706ae1e9e3f2b18d649c3bb9795c5ce14346fb818bd30f34011834af64b320c?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/f706ae1e9e3f2b18d649c3bb9795c5ce14346fb818bd30f34011834af64b320c?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/f706ae1e9e3f2b18d649c3bb9795c5ce14346fb818bd30f34011834af64b320c?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/f706ae1e9e3f2b18d649c3bb9795c5ce14346fb818bd30f34011834af64b320c?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/f706ae1e9e3f2b18d649c3bb9795c5ce14346fb818bd30f34011834af64b320c?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/f706ae1e9e3f2b18d649c3bb9795c5ce14346fb818bd30f34011834af64b320c?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                    className="img-10"
                  />
                  BUSINESS LAW
                </div>
              </div>
            </div>
          </div>
          <div className="div-54">
            <div className="div-55">
              <div className="column-10">
                <div className="div-56">
                  <img
                    loading="lazy"
                    srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/8b71c51e2c4b8ee001e84b43adbf56381b7d7f246f8d5c62e530fdc6c47aa323?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/8b71c51e2c4b8ee001e84b43adbf56381b7d7f246f8d5c62e530fdc6c47aa323?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/8b71c51e2c4b8ee001e84b43adbf56381b7d7f246f8d5c62e530fdc6c47aa323?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/8b71c51e2c4b8ee001e84b43adbf56381b7d7f246f8d5c62e530fdc6c47aa323?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/8b71c51e2c4b8ee001e84b43adbf56381b7d7f246f8d5c62e530fdc6c47aa323?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/8b71c51e2c4b8ee001e84b43adbf56381b7d7f246f8d5c62e530fdc6c47aa323?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/8b71c51e2c4b8ee001e84b43adbf56381b7d7f246f8d5c62e530fdc6c47aa323?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/8b71c51e2c4b8ee001e84b43adbf56381b7d7f246f8d5c62e530fdc6c47aa323?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                    className="img-11"
                  />
                  <br />
                  LANDLORD DISPUTES
                </div>
              </div>
              <div className="column-11">
                <div className="div-58">
                  <img
                    loading="lazy"
                    srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/845f4d39d554a388922343c32948427463a5411493645f431b38ac52bf5701ae?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/845f4d39d554a388922343c32948427463a5411493645f431b38ac52bf5701ae?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/845f4d39d554a388922343c32948427463a5411493645f431b38ac52bf5701ae?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/845f4d39d554a388922343c32948427463a5411493645f431b38ac52bf5701ae?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/845f4d39d554a388922343c32948427463a5411493645f431b38ac52bf5701ae?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/845f4d39d554a388922343c32948427463a5411493645f431b38ac52bf5701ae?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/845f4d39d554a388922343c32948427463a5411493645f431b38ac52bf5701ae?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/845f4d39d554a388922343c32948427463a5411493645f431b38ac52bf5701ae?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                    className="img-12"
                  />
                  ELDER ABUSE
                </div>
              </div>
            </div>
          </div>
          <div className="div-60">
            <div className="div-61">
              What says our
              <br />
              happy Clients
            </div>
            <img
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/7d3f1fdaac599714650010eec9fc688439469a0ddc3b2a44caf086d8d10c7ca1?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
              className="img-13"
            />
          </div>
          <div className="div-62">
            <div className="div-63">
              <div className="column-12">
                <div className="div-64">
                  <img
                    loading="lazy"
                    srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/778586b59b088e582a57f4d04d8d388488338a9f67dc5bc32559f14ed34a0097?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/778586b59b088e582a57f4d04d8d388488338a9f67dc5bc32559f14ed34a0097?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/778586b59b088e582a57f4d04d8d388488338a9f67dc5bc32559f14ed34a0097?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/778586b59b088e582a57f4d04d8d388488338a9f67dc5bc32559f14ed34a0097?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/778586b59b088e582a57f4d04d8d388488338a9f67dc5bc32559f14ed34a0097?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/778586b59b088e582a57f4d04d8d388488338a9f67dc5bc32559f14ed34a0097?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/778586b59b088e582a57f4d04d8d388488338a9f67dc5bc32559f14ed34a0097?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/778586b59b088e582a57f4d04d8d388488338a9f67dc5bc32559f14ed34a0097?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                    className="img-14"
                  />
                  <div className="div-65">Jane Cooper</div>
                  <div className="div-66">Ceo of Hunt</div>
                  <div className="div-67">
                    Amet minim mollit non deserunt ullamco est
                    <br />
                    sit aliqua dolor do amet sint. Velit officia
                    <br />
                    consequatduis enim velit mollit Exer. sit
                    <br />
                    aliqua dolor do amet sint. Velit officia
                  </div>
                </div>
              </div>
              <div className="column-13">
                <div className="div-68">
                  <img
                    loading="lazy"
                    srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/f5a0d2dec453aeb9659c2aef4c7d817907c707ada08191ae12264a62a251fd9b?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/f5a0d2dec453aeb9659c2aef4c7d817907c707ada08191ae12264a62a251fd9b?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/f5a0d2dec453aeb9659c2aef4c7d817907c707ada08191ae12264a62a251fd9b?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/f5a0d2dec453aeb9659c2aef4c7d817907c707ada08191ae12264a62a251fd9b?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/f5a0d2dec453aeb9659c2aef4c7d817907c707ada08191ae12264a62a251fd9b?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/f5a0d2dec453aeb9659c2aef4c7d817907c707ada08191ae12264a62a251fd9b?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/f5a0d2dec453aeb9659c2aef4c7d817907c707ada08191ae12264a62a251fd9b?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/f5a0d2dec453aeb9659c2aef4c7d817907c707ada08191ae12264a62a251fd9b?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                    className="img-15"
                  />
                  <div className="div-69">Devon Lane</div>
                  <div className="div-70">Ceo of Hunt</div>
                  <div className="div-71">
                    Amet minim mollit non deserunt ullamco est
                    <br />
                    sit aliqua dolor do amet sint. Velit officia
                    <br />
                    consequatduis enim velit mollit Exer. sit
                    <br />
                    aliqua dolor do amet sint. Velit officia
                  </div>
                </div>
              </div>
              <div className="column-14">
                <div className="div-72">
                  <img
                    loading="lazy"
                    srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/92c532af110b3d6c70f7bd35c39f20c6f1cd2e2a8bc5a8a5cf09de2de7c7c438?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/92c532af110b3d6c70f7bd35c39f20c6f1cd2e2a8bc5a8a5cf09de2de7c7c438?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/92c532af110b3d6c70f7bd35c39f20c6f1cd2e2a8bc5a8a5cf09de2de7c7c438?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/92c532af110b3d6c70f7bd35c39f20c6f1cd2e2a8bc5a8a5cf09de2de7c7c438?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/92c532af110b3d6c70f7bd35c39f20c6f1cd2e2a8bc5a8a5cf09de2de7c7c438?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/92c532af110b3d6c70f7bd35c39f20c6f1cd2e2a8bc5a8a5cf09de2de7c7c438?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/92c532af110b3d6c70f7bd35c39f20c6f1cd2e2a8bc5a8a5cf09de2de7c7c438?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/92c532af110b3d6c70f7bd35c39f20c6f1cd2e2a8bc5a8a5cf09de2de7c7c438?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                    className="img-16"
                  />
                  <div className="div-73">Robert Fox</div>
                  <div className="div-74">Ceo of Hunt</div>
                  <div className="div-75">
                    Amet minim mollit non deserunt ullamco est
                    <br />
                    sit aliqua dolor do amet sint. Velit officia
                    <br />
                    consequatduis enim velit mollit Exer. sit
                    <br />
                    aliqua dolor do amet sint. Velit officia
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="div-76">Our Team</div>
          <div className="div-77">
            <div className="div-78">
              <div className="column-15">
                <div className="div-79">
                  <div className="div-80">
                    <img
                      loading="lazy"
                      srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/9c0b1a3eaff476808d96353abffdd8824f1f6eb3ccb1326e4615847db9ccb06a?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/9c0b1a3eaff476808d96353abffdd8824f1f6eb3ccb1326e4615847db9ccb06a?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/9c0b1a3eaff476808d96353abffdd8824f1f6eb3ccb1326e4615847db9ccb06a?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/9c0b1a3eaff476808d96353abffdd8824f1f6eb3ccb1326e4615847db9ccb06a?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/9c0b1a3eaff476808d96353abffdd8824f1f6eb3ccb1326e4615847db9ccb06a?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/9c0b1a3eaff476808d96353abffdd8824f1f6eb3ccb1326e4615847db9ccb06a?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/9c0b1a3eaff476808d96353abffdd8824f1f6eb3ccb1326e4615847db9ccb06a?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/9c0b1a3eaff476808d96353abffdd8824f1f6eb3ccb1326e4615847db9ccb06a?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                      className="img-17"
                    />
                    <div className="div-81">
                      <div className="div-82">Danial Def</div>
                      <div className="div-83">301 Cases</div>
                    </div>
                  </div>
                  <div className="div-84">
                    <img
                      loading="lazy"
                      srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/4eaa327f8f8d76422d82b2f73d9523f03541073cb4a480cc6e6a62417bb20fd9?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/4eaa327f8f8d76422d82b2f73d9523f03541073cb4a480cc6e6a62417bb20fd9?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/4eaa327f8f8d76422d82b2f73d9523f03541073cb4a480cc6e6a62417bb20fd9?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/4eaa327f8f8d76422d82b2f73d9523f03541073cb4a480cc6e6a62417bb20fd9?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/4eaa327f8f8d76422d82b2f73d9523f03541073cb4a480cc6e6a62417bb20fd9?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/4eaa327f8f8d76422d82b2f73d9523f03541073cb4a480cc6e6a62417bb20fd9?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/4eaa327f8f8d76422d82b2f73d9523f03541073cb4a480cc6e6a62417bb20fd9?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/4eaa327f8f8d76422d82b2f73d9523f03541073cb4a480cc6e6a62417bb20fd9?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                      className="img-18"
                    />
                    <div className="div-85">
                      <div className="div-86">Colleen</div>
                      <div className="div-87">180 Cases</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="column-16">
                <div className="div-88">
                  <div className="div-89">
                    <img
                      loading="lazy"
                      srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/9717386e7acbfcced7bfa46e85dea6a2350eb70444b6c6091aec06b8d8521caa?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/9717386e7acbfcced7bfa46e85dea6a2350eb70444b6c6091aec06b8d8521caa?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/9717386e7acbfcced7bfa46e85dea6a2350eb70444b6c6091aec06b8d8521caa?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/9717386e7acbfcced7bfa46e85dea6a2350eb70444b6c6091aec06b8d8521caa?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/9717386e7acbfcced7bfa46e85dea6a2350eb70444b6c6091aec06b8d8521caa?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/9717386e7acbfcced7bfa46e85dea6a2350eb70444b6c6091aec06b8d8521caa?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/9717386e7acbfcced7bfa46e85dea6a2350eb70444b6c6091aec06b8d8521caa?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/9717386e7acbfcced7bfa46e85dea6a2350eb70444b6c6091aec06b8d8521caa?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                      className="img-19"
                    />
                    <div className="div-90">
                      <div className="div-91">Sanfole</div>
                      <div className="div-92">850 Cases</div>
                    </div>
                  </div>
                  <div className="div-93">
                    <img
                      loading="lazy"
                      srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/47ee214f9b870a17f02562d5edd67a13729306000eb145787c7a03e4b72f1e5e?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/47ee214f9b870a17f02562d5edd67a13729306000eb145787c7a03e4b72f1e5e?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/47ee214f9b870a17f02562d5edd67a13729306000eb145787c7a03e4b72f1e5e?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/47ee214f9b870a17f02562d5edd67a13729306000eb145787c7a03e4b72f1e5e?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/47ee214f9b870a17f02562d5edd67a13729306000eb145787c7a03e4b72f1e5e?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/47ee214f9b870a17f02562d5edd67a13729306000eb145787c7a03e4b72f1e5e?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/47ee214f9b870a17f02562d5edd67a13729306000eb145787c7a03e4b72f1e5e?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/47ee214f9b870a17f02562d5edd67a13729306000eb145787c7a03e4b72f1e5e?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                      className="img-20"
                    />
                    <div className="div-94">
                      <div className="div-95">Haldone</div>
                      <div className="div-96">212 Cases</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="column-17">
                <div className="div-97">
                  <div className="div-98">
                    <img
                      loading="lazy"
                      srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/495cb5bda23034d3bb4e4a9fb68b0943ed570f47d1b3103cd05c965faf40b8f5?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/495cb5bda23034d3bb4e4a9fb68b0943ed570f47d1b3103cd05c965faf40b8f5?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/495cb5bda23034d3bb4e4a9fb68b0943ed570f47d1b3103cd05c965faf40b8f5?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/495cb5bda23034d3bb4e4a9fb68b0943ed570f47d1b3103cd05c965faf40b8f5?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/495cb5bda23034d3bb4e4a9fb68b0943ed570f47d1b3103cd05c965faf40b8f5?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/495cb5bda23034d3bb4e4a9fb68b0943ed570f47d1b3103cd05c965faf40b8f5?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/495cb5bda23034d3bb4e4a9fb68b0943ed570f47d1b3103cd05c965faf40b8f5?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/495cb5bda23034d3bb4e4a9fb68b0943ed570f47d1b3103cd05c965faf40b8f5?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                      className="img-21"
                    />
                    <div className="div-99">
                      <div className="div-100">Cesforila</div>
                      <div className="div-101">470 Cases</div>
                    </div>
                  </div>
                  <div className="div-102">
                    <img
                      loading="lazy"
                      srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/0c1bbb4f3f8130befa33acef495ad3bacdc5a4f7bc5cfdd586a96dbe3e402602?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/0c1bbb4f3f8130befa33acef495ad3bacdc5a4f7bc5cfdd586a96dbe3e402602?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/0c1bbb4f3f8130befa33acef495ad3bacdc5a4f7bc5cfdd586a96dbe3e402602?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/0c1bbb4f3f8130befa33acef495ad3bacdc5a4f7bc5cfdd586a96dbe3e402602?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/0c1bbb4f3f8130befa33acef495ad3bacdc5a4f7bc5cfdd586a96dbe3e402602?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/0c1bbb4f3f8130befa33acef495ad3bacdc5a4f7bc5cfdd586a96dbe3e402602?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/0c1bbb4f3f8130befa33acef495ad3bacdc5a4f7bc5cfdd586a96dbe3e402602?apiKey=f472f26ac3b9476d953e83db26ba4da7&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/0c1bbb4f3f8130befa33acef495ad3bacdc5a4f7bc5cfdd586a96dbe3e402602?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                      className="img-22"
                    />
                    <div className="div-103">
                      <div className="div-104">Nik Jeo</div>
                      <div className="div-105">350 Cases</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="div-106">
            <div className="div-107">
              <div className="column">
                <div className="div-108">
                  <div className="div-109">FAQ</div>
                  <div className="div-110">
                    Amet minim mollit non deserunt ullamco est sit
                    <br />
                    aliqua dolor do amet sint.{" "}
                  </div>
                </div>
              </div>
              <div className="column-18">
                <div className="div-111">
                  Do I need a personal injury report?
                </div>
              </div>
            </div>
          </div>
          <div className="div-112">
            Amet minim mollit non deserunt ullamco est sit
            <br />
            aliqua dolor do amet sint. Velit officia consequatduis
            <br />
            enim velit mollit Exer. Amet minim mollit non deserunt
            <br />
            ullamco est sit aliqua dolor do amet sint. Velit officia
            consequatduis enim velit mollit Exer.
          </div>
          <div className="div-113" />
          <div className="div-114">
            <div className="div-115">How much is my case worth?</div>
            <div className="div-116">+</div>
          </div>
          <div className="div-117" />
          <div className="div-118">
            <div className="div-119">
              What should I do right after car accidect
            </div>
            <div className="div-120">+</div>
          </div>
          <div className="div-121" />
          <div className="div-122">
            <div className="div-123">How much is my case worth?</div>
            <div className="div-124">+</div>
          </div>
        </div>
        <div className="div-125">
          <div className="div-126">
            <div className="div-127">Subscribe Our Newsletter</div>
            <div className="div-128">
              <div className="div-129">Name : </div>
              <div className="div-130">Enter your Email</div>
              <div className="div-131">SEND</div>
            </div>
          </div>
        </div>
        <div className="div-132">
          <div className="div-133">
            <div className="div-134">
              <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/1c1f7f949264b43dc2741d62e020fc90b0652d332877f3ba5d8c4174153ca9ea?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                className="img-23"
              />
              <div className="div-135">
                <div className="div-136">Home </div>
                <div className="div-137">Attorneys</div>
                <div className="div-138">
                  <span style={{fontWeight: 700}}>Practice Areas</span>
                </div>
                <div className="div-139">About Us</div>
                <img
                  loading="lazy"
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/35d10214149a8d3c583b15ad2bee9e0b267ca781d09b3a5c25694d27f0494973?apiKey=f472f26ac3b9476d953e83db26ba4da7&"
                  className="img-24"
                />
              </div>
            </div>
            <div className="div-140">
              <div className="div-141">© 2020 Acme. All right reserved.</div>
              <div className="div-142">Privacy Policy</div>
              <div className="div-143">Terms of Service</div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .div {
          background-color: #1d1d1d;
          display: flex;
          flex-direction: column;
        }
        .div-2 {
          background-color: #111;
          display: flex;
          width: 100%;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 50px 60px;
        }
        @media (max-width: 991px) {
          .div-2 {
            max-width: 100%;
            padding: 0 20px;
          }
        }
        .div-3 {
          display: flex;
          margin-bottom: 104px;
          width: 100%;
          max-width: 1137px;
          flex-direction: column;
        }
        @media (max-width: 991px) {
          .div-3 {
            max-width: 100%;
            margin-bottom: 40px;
          }
        }
        .div-4 {
          display: flex;
          width: 100%;
          justify-content: space-between;
          gap: 20px;
        }
        @media (max-width: 991px) {
          .div-4 {
            max-width: 100%;
            flex-wrap: wrap;
          }
        }
        .img {
          aspect-ratio: 4.77;
          object-fit: contain;
          object-position: center;
          width: 143px;
          overflow: hidden;
          align-self: center;
          max-width: 100%;
          margin: auto 0;
        }
        .div-5 {
          align-self: center;
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 20px;
          margin: auto 0;
        }
        @media (max-width: 991px) {
          .div-5 {
            max-width: 100%;
            flex-wrap: wrap;
          }
        }
        .div-6 {
          color: var(--Pure-White, #fff);
          text-align: center;
          align-self: start;
          font: 600 16px/163% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-7 {
          color: var(--Pure-White, #fff);
          text-align: center;
          align-self: stretch;
          font: 600 16px/163% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-8 {
          color: var(--Pure-White, #fff);
          text-align: center;
          font: 600 16px/163% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-9 {
          color: var(--Pure-White, #fff);
          text-align: center;
          align-self: start;
          font: 600 16px/163% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-10 {
          color: var(--Pure-White, #fff);
          text-align: center;
          white-space: nowrap;
          border: 2px solid #fff;
          justify-content: center;
          padding: 20px 39px;
          font: 600 16px Inter, sans-serif;
        }
        @media (max-width: 991px) {
          .div-10 {
            white-space: initial;
            padding: 0 20px;
          }
        }
        .div-11 {
          margin-top: 70px;
          padding: 0 1px;
        }
        @media (max-width: 991px) {
          .div-11 {
            max-width: 100%;
            margin-top: 40px;
          }
        }
        .div-12 {
          gap: 20px;
          display: flex;
        }
        @media (max-width: 991px) {
          .div-12 {
            flex-direction: column;
            align-items: stretch;
            gap: 0px;
          }
        }
        .column {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: 55%;
          margin-left: 0px;
        }
        @media (max-width: 991px) {
          .column {
            width: 100%;
          }
        }
        .div-13 {
          display: flex;
          margin-top: 103px;
          flex-direction: column;
        }
        @media (max-width: 991px) {
          .div-13 {
            max-width: 100%;
            margin-top: 40px;
          }
        }
        .div-14 {
          color: var(--Pure-White, #fff);
          font: 400 66px/97px Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-14 {
            max-width: 100%;
            font-size: 40px;
            line-height: 66px;
          }
        }
        .div-15 {
          color: var(--Pure-White, #fff);
          margin-top: 53px;
          font: 500 18px/29px Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-15 {
            max-width: 100%;
            margin-top: 40px;
          }
        }
        .div-16 {
          border-radius: 43px;
          background-color: var(--Pure-White, #fff);
          display: flex;
          margin-top: 52px;
          justify-content: space-between;
          gap: 14px;
          padding: 6px 8px 6px 36px;
        }
        @media (max-width: 991px) {
          .div-16 {
            max-width: 100%;
            flex-wrap: wrap;
            padding-left: 20px;
            margin-top: 40px;
          }
        }
        .img-2 {
          aspect-ratio: 1;
          object-fit: contain;
          object-position: center;
          width: 22px;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          align-self: center;
          max-width: 100%;
          margin: auto 0;
        }
        .div-17 {
          color: var(--Pure-White, #fff);
          text-align: center;
          align-self: center;
          flex-grow: 1;
          flex-basis: auto;
          margin: auto 0;
          font: 500 16px/163% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-18 {
          color: #000;
          text-align: center;
          border-radius: 43px;
          background-color: #e3b748;
          flex-grow: 1;
          justify-content: center;
          padding: 25px 33px;
          font: 600 16px/163% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-18 {
            padding: 0 20px;
          }
        }
        .column-2 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: 45%;
          margin-left: 20px;
        }
        @media (max-width: 991px) {
          .column-2 {
            width: 100%;
          }
        }
        .img-3 {
          aspect-ratio: 0.86;
          object-fit: contain;
          object-position: center;
          width: 100%;
          overflow: hidden;
          flex-grow: 1;
        }
        @media (max-width: 991px) {
          .img-3 {
            max-width: 100%;
            margin-top: 40px;
          }
        }
        .div-19 {
          align-self: center;
          display: flex;
          margin-top: 156px;
          width: 100%;
          max-width: 1152px;
          flex-direction: column;
          padding: 0 20px;
        }
        @media (max-width: 991px) {
          .div-19 {
            max-width: 100%;
            margin-top: 40px;
          }
        }
        .div-20 {
          align-self: stretch;
          display: flex;
          justify-content: space-between;
          gap: 20px;
        }
        @media (max-width: 991px) {
          .div-20 {
            max-width: 100%;
            flex-wrap: wrap;
          }
        }
        .div-21 {
          color: var(--Pure-White, #fff);
          align-self: center;
          flex-grow: 1;
          flex-basis: auto;
          margin: auto 0;
          font: 600 54px/87px Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-21 {
            font-size: 40px;
            line-height: 71px;
          }
        }
        .div-22 {
          background-color: #6a6a6a;
          width: 1px;
          height: 206px;
        }
        .div-23 {
          align-self: center;
          display: flex;
          flex-grow: 1;
          flex-basis: 0%;
          flex-direction: column;
          margin: auto 0;
        }
        @media (max-width: 991px) {
          .div-23 {
            max-width: 100%;
          }
        }
        .div-24 {
          color: var(--Pure-White, #fff);
          text-align: center;
          font: 600 32px/163% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-24 {
            max-width: 100%;
          }
        }
        .div-25 {
          color: var(--Pure-White, #fff);
          margin-top: 30px;
          font: 500 18px/29px Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-25 {
            max-width: 100%;
          }
        }
        .div-26 {
          color: var(--Pure-White, #fff);
          align-self: center;
          margin-top: 188px;
          font: 600 54px/143% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-26 {
            max-width: 100%;
            font-size: 40px;
            margin-top: 40px;
          }
        }
        .div-27 {
          align-self: stretch;
          margin-top: 104px;
        }
        @media (max-width: 991px) {
          .div-27 {
            max-width: 100%;
            margin-top: 40px;
          }
        }
        .div-28 {
          gap: 20px;
          display: flex;
        }
        @media (max-width: 991px) {
          .div-28 {
            flex-direction: column;
            align-items: stretch;
            gap: 0px;
          }
        }
        .column-3 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: 33%;
          margin-left: 0px;
        }
        @media (max-width: 991px) {
          .column-3 {
            width: 100%;
          }
        }
        .div-29 {
          border-radius: 14px;
          border: 1.4px solid rgba(255, 255, 255, 0.1);
          background-color: #1d1d1d;
          display: flex;
          flex-grow: 1;
          flex-direction: column;
          width: 100%;
          padding: 33px 45px 33px 24px;
        }
        @media (max-width: 991px) {
          .div-29 {
            margin-top: 29px;
            padding: 0 20px;
          }
        }
        .img-4 {
          aspect-ratio: 1;
          object-fit: contain;
          object-position: center;
          width: 101px;
          overflow: hidden;
          align-self: start;
          max-width: 100%;
        }
        .div-30 {
          color: var(--Pure-White, #fff);
          align-self: stretch;
          margin-top: 31px;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-31 {
          color: var(--Pure-White, #fff);
          align-self: stretch;
          margin-top: 35px;
          font: 500 14px/23px Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-32 {
          color: #000;
          border-radius: 23.5px;
          background-color: #e3b748;
          align-self: stretch;
          margin-top: 25px;
          justify-content: center;
          padding: 17px 25px;
          font: 600 14px/163% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-32 {
            padding: 0 20px;
          }
        }
        .column-4 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: 33%;
          margin-left: 20px;
        }
        @media (max-width: 991px) {
          .column-4 {
            width: 100%;
          }
        }
        .div-33 {
          border-radius: 14px;
          border: 1.4px solid rgba(255, 255, 255, 0.1);
          background-color: #2e2e2e;
          display: flex;
          flex-grow: 1;
          flex-direction: column;
          width: 100%;
          padding: 33px 45px 33px 24px;
        }
        @media (max-width: 991px) {
          .div-33 {
            margin-top: 29px;
            padding: 0 20px;
          }
        }
        .img-5 {
          aspect-ratio: 1;
          object-fit: contain;
          object-position: center;
          width: 101px;
          overflow: hidden;
          align-self: start;
          max-width: 100%;
        }
        .div-34 {
          color: var(--Pure-White, #fff);
          align-self: stretch;
          margin-top: 31px;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-35 {
          color: var(--Pure-White, #fff);
          align-self: stretch;
          margin-top: 35px;
          font: 500 14px/23px Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-36 {
          color: #000;
          border-radius: 23.5px;
          background-color: #e3b748;
          align-self: stretch;
          margin-top: 25px;
          justify-content: center;
          padding: 17px 25px;
          font: 600 14px/163% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-36 {
            padding: 0 20px;
          }
        }
        .column-5 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: 33%;
          margin-left: 20px;
        }
        @media (max-width: 991px) {
          .column-5 {
            width: 100%;
          }
        }
        .div-37 {
          border-radius: 14px;
          border: 1.4px solid rgba(255, 255, 255, 0.1);
          background-color: #1d1d1d;
          display: flex;
          flex-grow: 1;
          flex-direction: column;
          width: 100%;
          padding: 33px 45px 33px 24px;
        }
        @media (max-width: 991px) {
          .div-37 {
            margin-top: 29px;
            padding: 0 20px;
          }
        }
        .img-6 {
          aspect-ratio: 1;
          object-fit: contain;
          object-position: center;
          width: 101px;
          overflow: hidden;
          align-self: start;
          max-width: 100%;
        }
        .div-38 {
          color: var(--Pure-White, #fff);
          align-self: stretch;
          margin-top: 31px;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-39 {
          color: var(--Pure-White, #fff);
          align-self: stretch;
          margin-top: 35px;
          font: 500 14px/23px Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-40 {
          color: #000;
          border-radius: 23.5px;
          background-color: #e3b748;
          align-self: stretch;
          margin-top: 25px;
          justify-content: center;
          padding: 17px 25px;
          font: 600 14px/163% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-40 {
            padding: 0 20px;
          }
        }
        .div-41 {
          color: var(--Pure-White, #fff);
          align-self: center;
          margin-top: 195px;
          font: 600 54px/143% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-41 {
            max-width: 100%;
            font-size: 40px;
            margin-top: 40px;
          }
        }
        .div-42 {
          align-self: stretch;
          margin-top: 83px;
        }
        @media (max-width: 991px) {
          .div-42 {
            max-width: 100%;
            margin-top: 40px;
          }
        }
        .div-43 {
          gap: 20px;
          display: flex;
        }
        @media (max-width: 991px) {
          .div-43 {
            flex-direction: column;
            align-items: stretch;
            gap: 0px;
          }
        }
        .column-6 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: 68%;
          margin-left: 0px;
        }
        @media (max-width: 991px) {
          .column-6 {
            width: 100%;
          }
        }
        .div-44 {
          disply: flex;
          flex-direction: column;
          color: #fffbf2;
          position: relative;
          white-space: nowrap;
          overflow: hidden;
          min-height: 342px;
          flex-grow: 1;
          justify-content: center;
          align-items: center;
          padding: 277px 60px 47px;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-44 {
            white-space: initial;
            max-width: 100%;
            margin-top: 30px;
            padding: 40px 20px 0;
          }
        }
        .img-7 {
          position: absolute;
          inset: 0;
          height: 100%;
          width: 100%;
          object-fit: cover;
          object-position: center;
        }
        .div-45 {
          position: relative;
        }
        .column-7 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: 32%;
          margin-left: 20px;
        }
        @media (max-width: 991px) {
          .column-7 {
            width: 100%;
          }
        }
        .div-46 {
          disply: flex;
          flex-direction: column;
          color: #fffbf2;
          position: relative;
          white-space: nowrap;
          overflow: hidden;
          aspect-ratio: 1.0467836257309941;
          flex-grow: 1;
          align-items: center;
          padding: 289px 60px 30px;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-46 {
            white-space: initial;
            margin-top: 30px;
            padding: 40px 20px 0;
          }
        }
        .img-8 {
          position: absolute;
          inset: 0;
          height: 100%;
          width: 100%;
          object-fit: cover;
          object-position: center;
        }
        .div-47 {
          position: relative;
        }
        .div-48 {
          align-self: stretch;
          margin-top: 30px;
        }
        @media (max-width: 991px) {
          .div-48 {
            max-width: 100%;
          }
        }
        .div-49 {
          gap: 20px;
          display: flex;
        }
        @media (max-width: 991px) {
          .div-49 {
            flex-direction: column;
            align-items: stretch;
            gap: 0px;
          }
        }
        .column-8 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: 32%;
          margin-left: 0px;
        }
        @media (max-width: 991px) {
          .column-8 {
            width: 100%;
          }
        }
        .div-50 {
          disply: flex;
          flex-direction: column;
          color: #fffbf2;
          position: relative;
          overflow: hidden;
          aspect-ratio: 1.0467836257309941;
          flex-grow: 1;
          justify-content: center;
          align-items: center;
          padding: 283px 60px 42px;
          font: 600 24px/24px Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-50 {
            margin-top: 30px;
            padding: 40px 20px 0;
          }
        }
        .img-9 {
          position: absolute;
          inset: 0;
          height: 100%;
          width: 100%;
          object-fit: cover;
          object-position: center;
        }
        .div-51 {
          position: relative;
        }
        .column-9 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: 68%;
          margin-left: 20px;
        }
        @media (max-width: 991px) {
          .column-9 {
            width: 100%;
          }
        }
        .div-52 {
          disply: flex;
          flex-direction: column;
          color: #fffbf2;
          position: relative;
          white-space: nowrap;
          overflow: hidden;
          min-height: 342px;
          flex-grow: 1;
          align-items: center;
          padding: 294px 60px 30px;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-52 {
            white-space: initial;
            max-width: 100%;
            margin-top: 30px;
            padding: 40px 20px 0;
          }
        }
        .img-10 {
          position: absolute;
          inset: 0;
          height: 100%;
          width: 100%;
          object-fit: cover;
          object-position: center;
        }
        .div-53 {
          position: relative;
        }
        .div-54 {
          align-self: stretch;
          margin-top: 30px;
        }
        @media (max-width: 991px) {
          .div-54 {
            max-width: 100%;
          }
        }
        .div-55 {
          gap: 20px;
          display: flex;
        }
        @media (max-width: 991px) {
          .div-55 {
            flex-direction: column;
            align-items: stretch;
            gap: 0px;
          }
        }
        .column-10 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: 68%;
          margin-left: 0px;
        }
        @media (max-width: 991px) {
          .column-10 {
            width: 100%;
          }
        }
        .div-56 {
          disply: flex;
          flex-direction: column;
          color: #fffbf2;
          position: relative;
          max-width: 253px;
          overflow: hidden;
          min-height: 342px;
          flex-grow: 1;
          justify-content: center;
          align-items: center;
          padding: 279px 60px 45px;
          font: 600 24px/24px Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-56 {
            max-width: 100%;
            margin-top: 30px;
            padding: 40px 20px 0;
          }
        }
        .img-11 {
          position: absolute;
          inset: 0;
          height: 100%;
          width: 100%;
          object-fit: cover;
          object-position: center;
        }
        .div-57 {
          position: relative;
        }
        .column-11 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: 32%;
          margin-left: 20px;
        }
        @media (max-width: 991px) {
          .column-11 {
            width: 100%;
          }
        }
        .div-58 {
          disply: flex;
          flex-direction: column;
          color: #fffbf2;
          position: relative;
          white-space: nowrap;
          overflow: hidden;
          aspect-ratio: 1.0467836257309941;
          flex-grow: 1;
          justify-content: center;
          align-items: center;
          padding: 278px 60px 47px;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-58 {
            white-space: initial;
            margin-top: 30px;
            padding: 40px 20px 0;
          }
        }
        .img-12 {
          position: absolute;
          inset: 0;
          height: 100%;
          width: 100%;
          object-fit: cover;
          object-position: center;
        }
        .div-59 {
          position: relative;
        }
        .div-60 {
          align-self: stretch;
          display: flex;
          margin-top: 205px;
          padding-right: 17px;
          align-items: start;
          justify-content: space-between;
          gap: 20px;
        }
        @media (max-width: 991px) {
          .div-60 {
            max-width: 100%;
            margin-top: 40px;
            flex-wrap: wrap;
          }
        }
        .div-61 {
          color: var(--Pure-White, #fff);
          flex-grow: 1;
          flex-basis: auto;
          font: 600 54px/77px Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-61 {
            font-size: 40px;
            line-height: 63px;
          }
        }
        .img-13 {
          aspect-ratio: 2.17;
          object-fit: contain;
          object-position: center;
          width: 200px;
          overflow: hidden;
          align-self: end;
          margin-top: 43px;
          max-width: 100%;
        }
        @media (max-width: 991px) {
          .img-13 {
            margin-top: 40px;
          }
        }
        .div-62 {
          align-self: stretch;
          margin-top: 99px;
        }
        @media (max-width: 991px) {
          .div-62 {
            max-width: 100%;
            margin-top: 40px;
          }
        }
        .div-63 {
          gap: 20px;
          display: flex;
        }
        @media (max-width: 991px) {
          .div-63 {
            flex-direction: column;
            align-items: stretch;
            gap: 0px;
          }
        }
        .column-12 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: 33%;
          margin-left: 0px;
        }
        @media (max-width: 991px) {
          .column-12 {
            width: 100%;
          }
        }
        .div-64 {
          border-radius: 14px;
          border: 1.4px solid rgba(255, 255, 255, 0.1);
          background-color: #1d1d1d;
          display: flex;
          margin-top: 4px;
          flex-grow: 1;
          flex-direction: column;
          width: 100%;
          padding: 40px 42px 40px 25px;
        }
        @media (max-width: 991px) {
          .div-64 {
            margin-top: 32px;
            padding: 0 20px;
          }
        }
        .img-14 {
          aspect-ratio: 1.03;
          object-fit: contain;
          object-position: center;
          width: 105px;
          overflow: hidden;
          border-radius: 50%;
          align-self: start;
          max-width: 100%;
        }
        .div-65 {
          color: var(--Pure-White, #fff);
          align-self: stretch;
          margin-top: 23px;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-66 {
          color: var(--Pure-White, #fff);
          align-self: stretch;
          margin-top: 14px;
          font: 400 14px/171% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-67 {
          color: var(--Pure-White, #fff);
          align-self: stretch;
          margin-top: 35px;
          font: 500 14px/23px Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .column-13 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: 33%;
          margin-left: 20px;
        }
        @media (max-width: 991px) {
          .column-13 {
            width: 100%;
          }
        }
        .div-68 {
          border-radius: 14px;
          border: 1.4px solid rgba(255, 255, 255, 0.1);
          background-color: #2e2e2e;
          display: flex;
          flex-grow: 1;
          flex-direction: column;
          width: 100%;
          padding: 40px 42px 40px 25px;
        }
        @media (max-width: 991px) {
          .div-68 {
            margin-top: 30px;
            padding: 0 20px;
          }
        }
        .img-15 {
          aspect-ratio: 1.03;
          object-fit: contain;
          object-position: center;
          width: 105px;
          overflow: hidden;
          border-radius: 50%;
          align-self: start;
          max-width: 100%;
        }
        .div-69 {
          color: var(--Pure-White, #fff);
          align-self: stretch;
          margin-top: 24px;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-70 {
          color: var(--Pure-White, #fff);
          align-self: stretch;
          margin-top: 19px;
          font: 400 14px/171% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-71 {
          color: var(--Pure-White, #fff);
          align-self: stretch;
          margin-top: 35px;
          font: 500 14px/23px Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .column-14 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: 33%;
          margin-left: 20px;
        }
        @media (max-width: 991px) {
          .column-14 {
            width: 100%;
          }
        }
        .div-72 {
          border-radius: 14px;
          border: 1.4px solid rgba(255, 255, 255, 0.1);
          background-color: #1d1d1d;
          display: flex;
          flex-direction: column;
          width: 100%;
          padding: 40px 42px 40px 25px;
        }
        @media (max-width: 991px) {
          .div-72 {
            margin-top: 28px;
            padding: 0 20px;
          }
        }
        .img-16 {
          aspect-ratio: 1.03;
          object-fit: contain;
          object-position: center;
          width: 105px;
          overflow: hidden;
          border-radius: 50%;
          align-self: start;
          max-width: 100%;
        }
        .div-73 {
          color: var(--Pure-White, #fff);
          align-self: stretch;
          margin-top: 24px;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-74 {
          color: var(--Pure-White, #fff);
          align-self: stretch;
          margin-top: 19px;
          font: 400 14px/171% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-75 {
          color: var(--Pure-White, #fff);
          align-self: stretch;
          margin-top: 35px;
          font: 500 14px/23px Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-76 {
          color: var(--Pure-White, #fff);
          align-self: center;
          margin-top: 203px;
          white-space: nowrap;
          font: 600 54px/143% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-76 {
            margin-top: 40px;
            font-size: 40px;
            white-space: initial;
          }
        }
        .div-77 {
          align-self: stretch;
          margin-top: 127px;
        }
        @media (max-width: 991px) {
          .div-77 {
            max-width: 100%;
            margin-top: 40px;
          }
        }
        .div-78 {
          gap: 20px;
          display: flex;
        }
        @media (max-width: 991px) {
          .div-78 {
            flex-direction: column;
            align-items: stretch;
            gap: 0px;
          }
        }
        .column-15 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: 33%;
          margin-left: 0px;
        }
        @media (max-width: 991px) {
          .column-15 {
            width: 100%;
          }
        }
        .div-79 {
          display: flex;
          margin-top: 18px;
          flex-grow: 1;
          flex-direction: column;
        }
        @media (max-width: 991px) {
          .div-79 {
            margin-top: 40px;
          }
        }
        .div-80 {
          display: flex;
          justify-content: space-between;
          gap: 20px;
        }
        .img-17 {
          aspect-ratio: 1;
          object-fit: contain;
          object-position: center;
          width: 68px;
          overflow: hidden;
          border-radius: 50%;
          max-width: 100%;
        }
        .div-81 {
          align-self: center;
          display: flex;
          flex-grow: 1;
          flex-basis: 0%;
          flex-direction: column;
          margin: auto 0;
        }
        .div-82 {
          color: var(--Pure-White, #fff);
          white-space: nowrap;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-82 {
            white-space: initial;
          }
        }
        .div-83 {
          color: var(--Pure-White, #fff);
          margin-top: 16px;
          font: 400 14px/171% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-84 {
          display: flex;
          margin-top: 85px;
          justify-content: space-between;
          gap: 20px;
        }
        @media (max-width: 991px) {
          .div-84 {
            margin-top: 40px;
          }
        }
        .img-18 {
          aspect-ratio: 1;
          object-fit: contain;
          object-position: center;
          width: 68px;
          overflow: hidden;
          border-radius: 50%;
          max-width: 100%;
        }
        .div-85 {
          align-self: center;
          display: flex;
          flex-grow: 1;
          flex-basis: 0%;
          flex-direction: column;
          margin: auto 0;
        }
        .div-86 {
          color: var(--Pure-White, #fff);
          white-space: nowrap;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-86 {
            white-space: initial;
          }
        }
        .div-87 {
          color: var(--Pure-White, #fff);
          margin-top: 16px;
          font: 400 14px/171% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .column-16 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: 47%;
          margin-left: 20px;
        }
        @media (max-width: 991px) {
          .column-16 {
            width: 100%;
          }
        }
        .div-88 {
          display: flex;
          flex-grow: 1;
          flex-direction: column;
        }
        @media (max-width: 991px) {
          .div-88 {
            margin-top: 40px;
          }
        }
        .div-89 {
          border-radius: 14px;
          background-color: #e3b748;
          display: flex;
          justify-content: space-between;
          gap: 20px;
          padding: 21px 80px 21px 26px;
        }
        @media (max-width: 991px) {
          .div-89 {
            padding: 0 20px;
          }
        }
        .img-19 {
          aspect-ratio: 1;
          object-fit: contain;
          object-position: center;
          width: 68px;
          overflow: hidden;
          border-radius: 50%;
          max-width: 100%;
        }
        .div-90 {
          align-self: center;
          display: flex;
          flex-grow: 1;
          flex-basis: 0%;
          flex-direction: column;
          margin: auto 0;
        }
        .div-91 {
          color: var(--Text-Black, #373737);
          white-space: nowrap;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-91 {
            white-space: initial;
          }
        }
        .div-92 {
          color: #000;
          margin-top: 16px;
          white-space: nowrap;
          font: 400 14px/171% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-92 {
            white-space: initial;
          }
        }
        .div-93 {
          align-self: start;
          display: flex;
          justify-content: space-between;
          gap: 20px;
          margin: 62px 0 0 26px;
        }
        @media (max-width: 991px) {
          .div-93 {
            margin: 40px 0 0 10px;
          }
        }
        .img-20 {
          aspect-ratio: 1;
          object-fit: contain;
          object-position: center;
          width: 68px;
          overflow: hidden;
          border-radius: 50%;
          max-width: 100%;
        }
        .div-94 {
          align-self: center;
          display: flex;
          flex-grow: 1;
          flex-basis: 0%;
          flex-direction: column;
          margin: auto 0;
        }
        .div-95 {
          color: var(--Pure-White, #fff);
          white-space: nowrap;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-95 {
            white-space: initial;
          }
        }
        .div-96 {
          color: var(--Pure-White, #fff);
          margin-top: 16px;
          white-space: nowrap;
          font: 400 14px/171% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-96 {
            white-space: initial;
          }
        }
        .column-17 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: 20%;
          margin-left: 20px;
        }
        @media (max-width: 991px) {
          .column-17 {
            width: 100%;
          }
        }
        .div-97 {
          display: flex;
          flex-direction: column;
          margin: auto 0;
        }
        @media (max-width: 991px) {
          .div-97 {
            margin-top: 40px;
          }
        }
        .div-98 {
          display: flex;
          justify-content: space-between;
          gap: 20px;
        }
        .img-21 {
          aspect-ratio: 1;
          object-fit: contain;
          object-position: center;
          width: 68px;
          overflow: hidden;
          border-radius: 50%;
          max-width: 100%;
        }
        .div-99 {
          align-self: center;
          display: flex;
          flex-grow: 1;
          flex-basis: 0%;
          flex-direction: column;
          margin: auto 0;
        }
        .div-100 {
          color: var(--Pure-White, #fff);
          white-space: nowrap;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-100 {
            white-space: initial;
          }
        }
        .div-101 {
          color: var(--Pure-White, #fff);
          margin-top: 16px;
          font: 400 14px/171% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-102 {
          display: flex;
          margin-top: 85px;
          justify-content: space-between;
          gap: 20px;
        }
        @media (max-width: 991px) {
          .div-102 {
            margin-top: 40px;
          }
        }
        .img-22 {
          aspect-ratio: 1;
          object-fit: contain;
          object-position: center;
          width: 68px;
          overflow: hidden;
          border-radius: 50%;
          max-width: 100%;
        }
        .div-103 {
          align-self: center;
          display: flex;
          flex-grow: 1;
          flex-basis: 0%;
          flex-direction: column;
          margin: auto 0;
        }
        .div-104 {
          color: var(--Pure-White, #fff);
          white-space: nowrap;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-104 {
            white-space: initial;
          }
        }
        .div-105 {
          color: var(--Pure-White, #fff);
          margin-top: 16px;
          font: 400 14px/171% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-106 {
          align-self: start;
          margin-top: 214px;
          width: 978px;
          max-width: 100%;
        }
        @media (max-width: 991px) {
          .div-106 {
            margin-top: 40px;
          }
        }
        .div-107 {
          gap: 20px;
          display: flex;
        }
        @media (max-width: 991px) {
          .div-107 {
            flex-direction: column;
            align-items: stretch;
            gap: 0px;
          }
        }
        .div-108 {
          display: flex;
          flex-grow: 1;
          flex-direction: column;
        }
        @media (max-width: 991px) {
          .div-108 {
            margin-top: 40px;
          }
        }
        .div-109 {
          color: var(--Pure-White, #fff);
          font: 600 54px/138% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-109 {
            font-size: 40px;
          }
        }
        .div-110 {
          color: var(--Pure-White, #fff);
          margin-top: 36px;
          font: 500 18px/29px Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .column-18 {
          display: flex;
          flex-direction: column;
          line-height: normal;
          width: 45%;
          margin-left: 20px;
        }
        @media (max-width: 991px) {
          .column-18 {
            width: 100%;
          }
        }
        .div-111 {
          color: var(--Pure-White, #fff);
          margin-top: 75px;
          white-space: nowrap;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-111 {
            margin-top: 40px;
            white-space: initial;
          }
        }
        .div-112 {
          color: var(--Pure-White, #fff);
          align-self: end;
          width: 557px;
          max-width: 100%;
          margin: 16px 64px 0 0;
          font: 500 18px/29px Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-112 {
            margin-right: 10px;
          }
        }
        .div-113 {
          background-color: #fff;
          align-self: end;
          margin-top: 41px;
          width: 539px;
          max-width: 100%;
          height: 2px;
        }
        @media (max-width: 991px) {
          .div-113 {
            margin-top: 40px;
          }
        }
        .div-114 {
          align-self: end;
          display: flex;
          margin-top: 37px;
          width: 539px;
          max-width: 100%;
          align-items: start;
          justify-content: space-between;
          gap: 20px;
        }
        @media (max-width: 991px) {
          .div-114 {
            flex-wrap: wrap;
          }
        }
        .div-115 {
          color: var(--Pure-White, #fff);
          margin-top: 5px;
          flex-grow: 1;
          flex-basis: auto;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-116 {
          color: #000;
          white-space: nowrap;
          border-radius: 50%;
          align-self: stretch;
          aspect-ratio: 1;
          justify-content: center;
          padding: 10px;
          font: 600 18px Inter, sans-serif;
        }
        @media (max-width: 991px) {
          .div-116 {
            white-space: initial;
          }
        }
        .div-117 {
          background-color: #fff;
          align-self: end;
          margin-top: 40px;
          width: 539px;
          max-width: 100%;
          height: 2px;
        }
        .div-118 {
          align-self: end;
          display: flex;
          margin-top: 44px;
          align-items: start;
          justify-content: space-between;
          gap: 20px;
        }
        @media (max-width: 991px) {
          .div-118 {
            max-width: 100%;
            flex-wrap: wrap;
            margin-top: 40px;
          }
        }
        .div-119 {
          color: var(--Pure-White, #fff);
          margin-top: 5px;
          flex-grow: 1;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        @media (max-width: 991px) {
          .div-119 {
            max-width: 100%;
          }
        }
        .div-120 {
          color: #000;
          white-space: nowrap;
          border-radius: 50%;
          align-self: stretch;
          aspect-ratio: 1;
          justify-content: center;
          padding: 10px;
          font: 600 18px Inter, sans-serif;
        }
        @media (max-width: 991px) {
          .div-120 {
            white-space: initial;
          }
        }
        .div-121 {
          background-color: #fff;
          align-self: end;
          margin-top: 40px;
          width: 539px;
          max-width: 100%;
          height: 2px;
        }
        .div-122 {
          align-self: end;
          display: flex;
          margin-top: 44px;
          width: 539px;
          max-width: 100%;
          align-items: start;
          justify-content: space-between;
          gap: 20px;
        }
        @media (max-width: 991px) {
          .div-122 {
            flex-wrap: wrap;
            margin-top: 40px;
          }
        }
        .div-123 {
          color: var(--Pure-White, #fff);
          margin-top: 5px;
          flex-grow: 1;
          flex-basis: auto;
          font: 600 24px/100% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-124 {
          color: #000;
          white-space: nowrap;
          border-radius: 50%;
          align-self: stretch;
          aspect-ratio: 1;
          justify-content: center;
          padding: 10px;
          font: 600 18px Inter, sans-serif;
        }
        @media (max-width: 991px) {
          .div-124 {
            white-space: initial;
          }
        }
        .div-125 {
          background-color: rgba(71, 71, 71, 0.5);
          align-self: center;
          display: flex;
          margin-top: 215px;
          width: 100%;
          max-width: 1245px;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 50px 60px;
        }
        @media (max-width: 991px) {
          .div-125 {
            max-width: 100%;
            margin-top: 40px;
            padding: 0 20px;
          }
        }
        .div-126 {
          display: flex;
          width: 686px;
          max-width: 100%;
          flex-direction: column;
          align-items: center;
          margin: 61px 0 43px;
        }
        @media (max-width: 991px) {
          .div-126 {
            margin: 40px 0;
          }
        }
        .div-127 {
          color: #fff;
          text-align: center;
          font: 500 55px/137% Helvetica Now Display, -apple-system, Roboto,
            Helvetica, sans-serif;
        }
        @media (max-width: 991px) {
          .div-127 {
            max-width: 100%;
            font-size: 40px;
          }
        }
        .div-128 {
          align-self: stretch;
          display: flex;
          margin-top: 58px;
          justify-content: space-between;
          gap: 9px;
        }
        @media (max-width: 991px) {
          .div-128 {
            max-width: 100%;
            flex-wrap: wrap;
            margin-top: 40px;
          }
        }
        .div-129 {
          color: #818181;
          border-radius: 8px 0px 0px 8px;
          background-color: #e4e4e4;
          flex-grow: 1;
          justify-content: center;
          align-items: start;
          padding: 22px 60px 22px 23px;
          font: italic 400 14px/137% Helvetica Now Display, -apple-system,
            Roboto, Helvetica, sans-serif;
        }
        @media (max-width: 991px) {
          .div-129 {
            padding: 0 20px;
          }
        }
        .div-130 {
          color: #818181;
          background-color: #e4e4e4;
          flex-grow: 1;
          justify-content: center;
          align-items: start;
          padding: 20px 60px 20px 14px;
          font: italic 400 14px/137% Helvetica Now Display, -apple-system,
            Roboto, Helvetica, sans-serif;
        }
        @media (max-width: 991px) {
          .div-130 {
            padding-right: 20px;
          }
        }
        .div-131 {
          color: #000;
          text-align: center;
          border-radius: 0px 8px 8px 0px;
          background-color: #e3b748;
          justify-content: center;
          padding: 22px 40px;
          font: 700 14px/137% Helvetica Now Display, -apple-system, Roboto,
            Helvetica, sans-serif;
        }
        @media (max-width: 991px) {
          .div-131 {
            padding: 0 20px;
          }
        }
        .div-132 {
          background-color: #171717;
          display: flex;
          margin-top: 242px;
          width: 100%;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 50px 60px;
        }
        @media (max-width: 991px) {
          .div-132 {
            max-width: 100%;
            margin-top: 40px;
            padding: 0 20px;
          }
        }
        .div-133 {
          display: flex;
          width: 100%;
          max-width: 1134px;
          flex-direction: column;
          margin: 68px 0 50px;
        }
        @media (max-width: 991px) {
          .div-133 {
            max-width: 100%;
            margin: 40px 0;
          }
        }
        .div-134 {
          display: flex;
          width: 100%;
          justify-content: space-between;
          gap: 20px;
        }
        @media (max-width: 991px) {
          .div-134 {
            max-width: 100%;
            flex-wrap: wrap;
          }
        }
        .img-23 {
          aspect-ratio: 4.77;
          object-fit: contain;
          object-position: center;
          width: 143px;
          overflow: hidden;
          max-width: 100%;
        }
        .div-135 {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 20px;
        }
        @media (max-width: 991px) {
          .div-135 {
            max-width: 100%;
            flex-wrap: wrap;
          }
        }
        .div-136 {
          color: #fff;
          letter-spacing: 0.1px;
          align-self: center;
          margin: auto 0;
          font: 400 16px/150% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-137 {
          color: var(--Pure-White, #fff);
          align-self: center;
          margin: auto 0;
          font: 600 16px/163% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-138 {
          color: #fff;
          letter-spacing: 0.1px;
          margin: auto 0;
          font: 400 16px/150% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .div-139 {
          color: var(--Pure-White, #fff);
          align-self: center;
          margin: auto 0;
          font: 600 16px/163% Inter, -apple-system, Roboto, Helvetica,
            sans-serif;
        }
        .img-24 {
          aspect-ratio: 6.23;
          object-fit: contain;
          object-position: center;
          width: 187px;
          overflow: hidden;
          align-self: stretch;
          max-width: 100%;
        }
        .div-140 {
          align-self: center;
          display: flex;
          margin-top: 106px;
          align-items: start;
          justify-content: space-between;
          gap: 20px;
        }
        @media (max-width: 991px) {
          .div-140 {
            max-width: 100%;
            flex-wrap: wrap;
            margin-top: 40px;
          }
        }
        .div-141 {
          color: #fff;
          align-self: stretch;
          flex-grow: 1;
          white-space: nowrap;
          font: 400 14px/143% Helvetica Now Display, -apple-system, Roboto,
            Helvetica, sans-serif;
        }
        @media (max-width: 991px) {
          .div-141 {
            white-space: initial;
          }
        }
        .div-142 {
          color: #fff;
          align-self: stretch;
          font: 400 14px/143% Helvetica Now Display, -apple-system, Roboto,
            Helvetica, sans-serif;
        }
        .div-143 {
          color: #fff;
          flex-grow: 1;
          white-space: nowrap;
          font: 400 14px/143% Helvetica Now Display, -apple-system, Roboto,
            Helvetica, sans-serif;
        }
        @media (max-width: 991px) {
          .div-143 {
            white-space: initial;
          }
        }
      `}</style>
    </>
  );
}


